import { render, staticRenderFns } from "./StockManagementDetail.vue?vue&type=template&id=44055104&"
import script from "./StockManagementDetail.vue?vue&type=script&lang=js&"
export * from "./StockManagementDetail.vue?vue&type=script&lang=js&"
import style0 from "./StockManagementDetail.vue?vue&type=style&index=0&id=44055104&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports